// The sign-up's price fields can open with the quote's price in them
// ("£300,000"), so a client who types their price without clearing the field
// gets "£300,000310000". The shared isMoneyValid strips commas before checking
// and so accepts that; these fields need any commas in the right places. No
// spaces either: the backend strips only "£" and commas, so "£ 300,000" would
// be saved as £0.
const PRICE_FORMAT = /^£?(\d{1,3}(,\d{3})+|\d+)(\.\d{1,2})?$/;

// Well above the £4 million we’re insured for (the quote page turns those
// cases away), so it catches a mistyped price, never a real one.
export const MAX_SIGNUP_PRICE = 10000000;

export const PRICE_MISSING = "Enter the property price";
export const PRICE_MALFORMED = "Enter the price in pounds, for example £350,000";
export const PRICE_TOO_HIGH = "Enter a price under £10 million";

// The message to show for a sign-up price field, or null when the price is fine.
export const signupPriceError = (price) => {
  const trimmed = String(price ?? "").trim();
  if (!trimmed) return PRICE_MISSING;
  if (!PRICE_FORMAT.test(trimmed)) return PRICE_MALFORMED;

  const pounds = parseFloat(trimmed.replace(/[£,]/g, ""));
  if (pounds <= 0) return PRICE_MALFORMED;
  if (pounds >= MAX_SIGNUP_PRICE) return PRICE_TOO_HIGH;
  return null;
};
